var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgGcPrint(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4113_5885)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.6562 1.16553H2.33115C1.6874 1.16553 1.16553 1.6874 1.16553 2.33115V4.6624C1.16553 5.30616 1.6874 5.82803 2.33115 5.82803H11.6562C12.2999 5.82803 12.8218 5.30616 12.8218 4.6624V2.33115C12.8218 1.6874 12.2999 1.16553 11.6562 1.16553Z",
    stroke: "#1D1D1F",
    strokeWidth: 1.16562,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6562 8.15918H2.33115C1.6874 8.15918 1.16553 8.68105 1.16553 9.3248V11.6561C1.16553 12.2998 1.6874 12.8217 2.33115 12.8217H11.6562C12.2999 12.8217 12.8218 12.2998 12.8218 11.6561V9.3248C12.8218 8.68105 12.2999 8.15918 11.6562 8.15918Z",
    stroke: "#1D1D1F",
    strokeWidth: 1.16562,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.49683 3.49707H3.50265",
    stroke: "#1D1D1F",
    strokeWidth: 1.16562,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.49683 10.4907H3.50265",
    stroke: "#1D1D1F",
    strokeWidth: 1.16562,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4113_5885"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13.9875,
    height: 13.9875,
    fill: "white"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGcPrint);
export default __webpack_public_path__ + "static/media/gc_print.ca63a8429eaf8f537452f3abaf636468.svg";
export { ForwardRef as ReactComponent };